<template>
    <div>
        <v-snackbar
            v-model="showInstallApp"
            color="accent" bottom right multi-line
            :timeout="5000" @click.native="installApp"
        >
            {{ $t('common.install_app') }}
            <template v-slot:action="{ attrs }">
                <v-btn fab icon v-bind="attrs" @click.stop="showInstallApp = false">
                    <v-icon>mdi-close-circle</v-icon>
                </v-btn>
            </template>
        </v-snackbar>

        <v-snackbar
            v-model="showInstallAppIos"
            color="#f0f6fd" :timeout="-1"
            :class="['snackbar-ios ', {'arrow-ios': showInstallAppIos}]"
            @click.native="showInstallAppIos = false"
        >
            <v-row dense align="center">
                <v-col cols="2" align="center">
                    <v-icon large color='#7f8c8d'>mdi-plus-box</v-icon>
                </v-col>
                <v-col cols="10" class="black--text">
                    {{ $t('common.install_app_ios_1') }}
                    <v-icon size="18" color='#1f6b9e'>mdi-export-variant</v-icon>
                    {{ $t('common.install_app_ios_2') }}
                </v-col>
            </v-row>
        </v-snackbar>
    </div>
</template>

<script>
export default {
    name: "KimsaInstallToast",
    data() {
        return {
            showInstallApp: false,
            showInstallAppIos: false,
        }
    },
    created() {
        const vm = this
        vm.showInstallAppMessage()
    },
    methods: {
        showInstallAppMessage() {
            const vm = this
            // SHOW ALERT IF DONT HAVE INSTALLED APP AND DESKTOP
            if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                window.addEventListener("beforeinstallprompt", event => {
                    setTimeout(() => {
                        vm.showInstallApp = true
                    }, 3000)
                    window.deferedPrompt = event;
                });
            }

            // Detects if device is on iOS and show Message
            const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);
            if (vm.isIphone && !isInStandaloneMode()) vm.showInstallAppIos = true
        },
        installApp() {
            const vm = this
            const promptEvent = window.deferedPrompt;
            promptEvent.prompt()
            promptEvent.userChoice.then(result => {
                result.outcome === 'accepted' ?
                    console.log('User accept the prompt') :
                    console.log('User dismissed the prompt')
                vm.showInstallApp = false;
                window.deferedPrompt = null;
            });
        }
    }
}
</script>

<style scoped>

.snackbar-ios {
    position: fixed !important;
    top: -28px !important;
}

.arrow-ios::before {
    content: "";
    width: 20px;
    height: 20px;
    transform: rotate(-45deg);
    background: #f0f6fd;
    position: absolute;
    z-index: 10;
    bottom: -2px;
    left: calc(50% - 10px);
    box-shadow: -5px 5px 5px 1px rgba(0, 0, 0, 0.2);
}

</style>